(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  let lenis;
  let contentResizeObserver;

  function destroy() {
    contentResizeObserver?.disconnect();
    contentResizeObserver = undefined;
    lenis?.destroy();
    lenis = undefined;
  }

  function initialize() {
    destroy();

    if (
      !desktopQuery.matches ||
      reducedMotionQuery.matches ||
      window.Shopify?.designMode ||
      typeof window.Lenis === 'undefined'
    ) {
      return;
    }

    const wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return;

    lenis = new window.Lenis({
      wrapper,
      content: wrapper,
      eventsTarget: wrapper,
      autoRaf: true,
      smoothWheel: true,
      syncTouch: false,
      lerp: 0.1,
      wheelMultiplier: 0.9,
      anchors: true,
      allowNestedScroll: true,
      stopInertiaOnNavigate: true,
    });

    contentResizeObserver = new ResizeObserver(() => {
      lenis?.resize();
    });

    for (const child of wrapper.children) {
      if (child instanceof HTMLElement && child.tagName !== 'SCRIPT') {
        contentResizeObserver.observe(child);
      }
    }
  }

  desktopQuery.addEventListener('change', initialize);
  reducedMotionQuery.addEventListener('change', initialize);
  window.addEventListener('pagehide', destroy, { once: true });

  initialize();
})();
